import { render } from "./SubmittingDialog.vue?vue&type=template&id=71d1bd4a"
import script from "./SubmittingDialog.vue?vue&type=script&lang=js"
export * from "./SubmittingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__